import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';

import { ListSearch } from '@fry/lib/list';


@Injectable()
export class UserFieldsSearch implements ListSearch {

  private fulltext() {
    return of({
      id: 'text',
      label: '',
      featured: true,
      filter: (item, value): Observable<boolean> => {
        return of(item.doc.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      },
      widget: {
        type: 'string',
        placeholder: $localize `Full text search`,
      }
    });
  }

  private nofulltext() {
    const flt = {
      id: 'nofulltext',
      label: $localize `Exclude Full text search`,
      filter: (item, value) => {
        return of(item.doc.name.toLowerCase().indexOf(value.toLowerCase()) === -1);
      },
      widget: {
        type: 'string'
      }
    };

    return of(flt);
  }

  public filters() {
    const _filters = [
      this.fulltext(),
      this.nofulltext()
    ];

    return forkJoin(_filters);
  }

  public sorts() {
    return of([
      {
        id: 'alphabetical',
        name: $localize `Name`,
        sort: (itemA, itemB) => {
          return itemA.doc.name.toLowerCase() > itemB.doc.name.toLowerCase() ? 1 : -1;
        }
      },
      {
        id: 'alphabetical_type',
        name: $localize `Type`,
        sort: (itemA, itemB) => {
          return itemA.doc.fieldType.toLowerCase() > itemB.doc.fieldType.toLowerCase() ? 1 : -1;
        }
      }
    ]);
  }
}
